// src/components/Home/Features.js
import React from "react";
import MapPage from "../MapPage/MapPage"; // Import the MapComponent

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>MAP SHOWING OUR DATA</h2>
        </div>
        <MapPage /> {/* Add the MapPage component here */}
      </div>
    </div>
  );
};
